import router from '@/router'
import { createRecord } from '@/utils/api'
import { USER_REQUEST } from '@/store/actions/user'
import {
  AUTH_ERROR,
  AUTH_LOGOUT,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_PERMISSIONS
} from '@/store/actions/auth'

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  permissions: []
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  permissions: state => state.permissions
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    commit(AUTH_REQUEST)
    return new Promise((resolve, reject) => {
      createRecord('login', user).then(response => {
        const token = response.key
        localStorage.setItem('user-token', token)
        commit(AUTH_SUCCESS, token)
        dispatch(USER_REQUEST)
        resolve()
      }).catch(error => {
        commit(AUTH_ERROR, error)
        localStorage.removeItem('user-token')
        reject(error)
      })
    })
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('user-token')
      router.push({ name: 'login', query: {} })
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, token) => {
    state.status = 'success'
    state.token = token
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
    state.status = ''
  },
  [AUTH_PERMISSIONS]: (state, preferences) => {
    if (preferences && preferences.permissions) {
      state.permissions = preferences.permissions
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
